// Copied from /server as a workaround for loader issue with enums
// https://github.com/facebook/create-react-app/issues/8987
export enum PointStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  PLANNED = "PLANNED",
  DEPRECATED = "DEPRECATED",
}
